// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link from 'next/link'
import * as React from 'react'
import styled from 'styled-components'

// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-responsive-images
import { Clock, ProgressiveAsset, TypeStyleBodySmall } from '@syconium/little-miss-figgy'

import { useLocalization } from '../../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { BadgesSection } from '../../../../../components/pages/products/ProductPage/ProductHighlights/BadgesSection'
import { trackEvent } from '../../../../../lib/analytics'
import { GtmVariant } from '../../../../../lib/hooks/useGoogleTagManager'
import { CartItem } from '../../../../../types/figs'
import { CartItemProperties } from '../CartItemProperties'

import { Body, Details, FitDescription, ImagePlaceholder, OptionsText, Title, Top } from './styles'

export const Template: React.FC<{
  cartItem: CartItem
  eventCategory: 'minicart' | 'cart'
  propertiesToDisplay: CartItem['properties']
  pushProductClick(data: { variant: GtmVariant; list?: string; position?: number }): void
}> = ({
  cartItem: {
    colorDisplayValue,
    effectivePrice,
    finalSale,
    fitDisplayValue,
    fullPrice,
    shopifyProductId,
    image,
    productGroupHandle,
    productType,
    properties,
    sizeDisplayValue,
    sku,
    title,
    variantId,
    isLowInventory,
    urlPath,
  },
  eventCategory,
  propertiesToDisplay,
  pushProductClick,
}) => {
  const { region } = useLocalization()
  const { pages, cart: miniCartCopy } = useTranslation()

  const linkHref = urlPath

  // pull out the property for final sale because there is a separate badge with different formatting
  // for final sale than other properties, but we still want the line item prop for the checkout page
  const { [miniCartCopy.finalSale]: finalSaleProp, ...otherPropertiesToDisplay } =
    propertiesToDisplay

  //is the product itself finalSale (socks) or is the kit marked as final Sale
  const isFinalSaleBadgeVisible = finalSale || finalSaleProp

  return (
    <Body data-testid='cart-kit-item' data-cart-item-id={properties._setUid}>
      <Top>
        <Link
          href={linkHref}
          onClick={() => {
            pushProductClick({
              variant: {
                category: productType,
                externalParentId: shopifyProductId,
                currencyType: region.currency,
                discountPrice: effectivePrice,
                handle: productGroupHandle,
                price: fullPrice,
                shopifyId: variantId,
                sku,
              },
              list: `${eventCategory}-cart`,
            })
          }}
          {...trackEvent({
            category: 'minicart 2.0',
            action: 'click item thumbnail',
            label: linkHref,
          })}
        >
          {image?.url ? (
            <ProgressiveAsset.Image src={image.url} alt={title} />
          ) : (
            <ImagePlaceholder />
          )}
        </Link>

        <Details>
          <div>
            <Title>
              {title} {productType}
            </Title>

            <OptionsText>
              {sizeDisplayValue}
              {fitDisplayValue && <FitDescription>&nbsp;• {fitDisplayValue}</FitDescription>}
              &nbsp;• {colorDisplayValue}
            </OptionsText>

            <CartItemProperties properties={otherPropertiesToDisplay} />

            {isFinalSaleBadgeVisible && <BadgesSection badges={[miniCartCopy.finalSale]} />}
          </div>
        </Details>
      </Top>
      {isLowInventory && (
        <LowInventoryTypography>
          <Clock />
          {pages.product.lowInventoryWarning}
        </LowInventoryTypography>
      )}
    </Body>
  )
}

const LowInventoryTypography = styled(TypeStyleBodySmall)`
  color: ${o => o.theme.color.text.caution.on.background};
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  margin: ${o => o.theme.spacing(6, 0, 0, 0)};
`
